<template>
  <h4>Contact National Student Services, Inc.</h4>
  <p>
    If you have any questions regarding your policy, feel free to contact us.
  </p>
  <hr />
  <p>
    • <b>Mailing Address:</b> PO Box 2137, Stillwater, OK 74076<br />
    • <b>Phone: </b> <a href="tel:8002566774" target="_blank">800-256-6774</a> -
    We are available 8am – 6pm, CST, Monday – Friday<br />
    • <b>Email: </b>
    <a href="mailto:customerservice@nssi.com" target="_blank" class="emailLink"
      >customerservice@nssi.com</a
    >
    <a href="https://www.nssi.com/contact-us" target="_blank">Online Form</a
    ><br />
    • <b>Online Chat:</b> Available 9am – 5pm, CST, Monday – Friday
  </p>
  <hr />
  <p>
    To contact our partner Assurant you can do so
    <a href="https://assurantrenters.com/" target="_blank">here.</a>
  </p>
</template>

<style scoped>
.emailLink {
  margin-right: 10px;
}
</style>
